export default function SecBtn(props){


    return(
        <button onClick={props.extlink} className='secbtn'>{props.btntext}</button>
    )
}